import { cover, rem } from 'polished';
import styled from 'styled-components';

import { getAspectRatioRate } from '../../helpers';
import { IAvatarWrapperProps } from './Avatar.types';

export const StyledImage = styled.img`
  ${cover()}
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StyledWrapper = styled.div<IAvatarWrapperProps>`
  position: relative;
  border-radius: 100%;
  overflow: hidden;

  &::before {
    display: block;
    padding-top: ${getAspectRatioRate(1, 1)};
    content: '';
  }

  ${({ size }) =>
    size && size.substr(-2) === 'px'
      ? `
    width: ${rem(size)};
  `
      : `
    width: ${size};
  `}
`;
